import { Link } from "react-router-dom";
import type { NewsArticle } from "@/mocks/news";

interface NewsListItemProps {
  article: NewsArticle;
}

export default function NewsListItem({ article }: NewsListItemProps) {
  return (
    <Link
      to={`/news/detail/${article.id}`}
      className="group flex flex-col sm:flex-row gap-4 p-3 md:p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full sm:w-44 lg:w-52 shrink-0 aspect-[16/10] rounded-md overflow-hidden bg-background-200">
        <img
          src={article.cover}
          alt={`${article.title} 封面`}
          title={`${article.title} 影视资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">
            {article.category}
          </span>
          <span>{article.date}</span>
        </div>
        <h3 className="mt-2 font-heading text-base md:text-lg font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-700 transition-colors">
          {article.title}
        </h3>
        <p className="mt-1.5 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {article.summary}
        </p>
        <div className="mt-2 flex items-center gap-1 text-xs text-foreground-500">
          <i className="ri-user-3-line" />
          <span>{article.author}</span>
        </div>
      </div>
    </Link>
  );
}